import { FILTER_STATUS_ID_MAP } from '@framework/ui/Organisms/Filters/constants';
import { formatNumberWithDecimals } from '@/creditflowresearch/ui/components/deals/helpers';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import { useTableDictionaries } from '@/creditflowresearch/application/TableDictionaries';
import {
  getTooltipForBondScreenerCellSize,
} from '@/creditflowresearch/ui/common/helpers/getTooltipForBondScreenerCellSize';

interface ISizeValue {
  tranche: number | null,
  deal: number | null,
  descriptionId: string | null,
}

interface ISizeCellProps {
  value?: ISizeValue,
  currencyId: string,
  statusId?: number,
  showCurrencyPrefix?: boolean,
  decimals?: number,
}

const EXCLUDED_STATUSES_FOR_DESCRIPTION = [
  FILTER_STATUS_ID_MAP.launched,
  FILTER_STATUS_ID_MAP.priced,
];

const SizeCell = ({ value, currencyId, statusId, showCurrencyPrefix = false, decimals = 0 }: ISizeCellProps) => {
  const { currencies, sizeDescriptions } = useTableDictionaries();

  if (!value) {
    return (<>-</>);
  }

  const currency = currencies.getById(currencyId);
  const currencyLabel = currency?.abbreviation ?? '';

  const formattedTrancheSize = formatNumberWithDecimals(value.tranche ?? 0, decimals);
  const formattedDealSize = formatNumberWithDecimals(value.deal ?? 0, decimals);

  const shouldShowDescription = statusId
    && value.descriptionId
    && !EXCLUDED_STATUSES_FOR_DESCRIPTION.includes(statusId);

  const description = shouldShowDescription
    ? sizeDescriptions.getById(value.descriptionId)
    : null;

  const descriptionName = description?.name ?? '';
  const descriptionAbbreviation = description?.abbreviation ?? '';

  const displayedTrancheSize = showCurrencyPrefix ? `${ currencyLabel }${ formattedTrancheSize }` : formattedTrancheSize;

  return (
    <Tooltip content={ getTooltipForBondScreenerCellSize({
      dealSize: formattedDealSize,
      trancheSize: formattedTrancheSize,
      currencyLabel,
      suffix: descriptionName,
    }) }
    >
      { displayedTrancheSize } { descriptionAbbreviation.toLowerCase() }
    </Tooltip>
  );
};

export default SizeCell;
